import React from "react"
import Img from "gatsby-image"
import { ImgItem } from "./image-item"

const AboutSharing = ({ image }) => {
  return (
    <ImgItem>
      <div className="textWrapper">
        <h1>Sharing & Show History</h1>

        <p1>
          Sharing times couldn’t be easier. You can share your show times via
          the iOS Share Sheet. You can also choose to include “In-Act Timers”
          when sharing as well.
        </p1>

        <p1>
          All previous performances are now stored, so you can revisit earlier
          performance times.
        </p1>
      </div>

      <Img fluid={image.childImageSharp.fluid} alt="Image" className="image" />
    </ImgItem>
  )
}

export default AboutSharing
